// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__15BFq","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3RhHw"};